/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Explicit no-action decision for the current execution.
 */
export type EmployeeExecutionNoActionOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionNoActionOperation.kind;
    /**
     * Reason no business action is currently applicable.
     */
    reason: string;
};
export namespace EmployeeExecutionNoActionOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        NO_ACTION = 'no-action',
    }
}

